'use client';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomImage from '@components/CustomImage';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';

export default function LsqSodicExperience(props: MarketingPageComponentProps) {
  const experienceSection = props?.locale?.section?.find(
    (section: any) => section.type === 'experience' && section.enabled
  );
  if (!experienceSection) return null;
  const elements = experienceSection?.lsqSodicExperienceElements ?? [];

  return (
    <Stack component="section" className={cn.sodicExperienceWrapper}>
      <CommonContainer
        paddingInline={{ xs: '1.25rem' }}
        maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
        flexGrow={1}
      >
        <Box className={cn.sodicExperienceInner}>
          <Box
            className={cn.sodicExperienceHeader}
            {...mergeAos(fadeUpAosProps, getAosDelay(200))}
          >
            <ParallaxText
              variant="h2"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(experienceSection.lsqSodicExperienceHeading)}
            </ParallaxText>
          </Box>
          <Box
            className={cn.sodicExperienceBody}
            {...mergeAos(fadeUpAosProps, getAosDelay(300))}
          >
            <List className={cn.sodicExperienceList}>
              {elements.map((item: any, index: number) => (
                <ListItem
                  key={index}
                  className={cn.sodicExperienceItem}
                  {...mergeAos(fadeUpAosProps, getAosDelay(index * 100))}
                >
                  <Box className={cn.sodicExperienceElement}>
                    <Box className={cn.sodicExperienceImage}>
                      <CustomImage
                        src={item.url}
                        alt={item.alt}
                        width={600}
                        height={400}
                      />
                    </Box>
                    <Box className={cn.sodicExperienceContent}>
                      {item.heading && (
                        <ParallaxText
                          variant="h3"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(item.heading)}
                        </ParallaxText>
                      )}
                      {item.content && (
                        <ParallaxText
                          variant="p"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(item.content)}
                        </ParallaxText>
                      )}
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </CommonContainer>
    </Stack>
  );
}
